export const environment = {
    apiUrl: 'https://api.requisitionforms.idexx.com/'
  };
  



